import { StatutDeclaration } from '@common/services';

export const ETABLISSEMENT_STATUT_FICHIER_TEXTS: Record<StatutDeclaration, string> = {
  [StatutDeclaration.NON_TELECHARGEE]: 'Non téléchargée',
  [StatutDeclaration.NON_DEPOSEE]: 'Non déposée',
  [StatutDeclaration.PARTIELLE]: 'Partielle',
  [StatutDeclaration.DEPOSEE]: 'Déposée',
};